<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <vuexy-logo />
      <h2 class="brand-text text-primary ml-1">
        Vuexy
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          You are active now
        </h2>
        <p class="mb-2">
          You will automatically be redirecting
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="{path:'/'}"
        >
          Wait Please
        </b-button>

        <!-- image -->
        <b-img
          fluid
          :src="imgUrl"
          alt="email activation"
        />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
import EmailActivation from '@/views/logics/error/EmailActivation'

export default {
  mixins: [EmailActivation],
}
</script>

<style lang="scss">
    @import '@core/scss/vue/pages/page-misc.scss';
</style>
